import * as types from '../service/actionTypes';

export default function liveTrackingState(state = {
                                         liveTrackingData: {}
                                     },
                                     action) {
    switch (action.type) {
        case types.LIVE_TRACKING_DATA:
            return {
                ...state,
                liveTrackingData: action.liveTrackingData
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/liveTrackingReducer.js